'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentWrapperStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = function style(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var thickness = theme.reactackle.components.progress.linear.thickness;
  var colourDefault = theme.reactackle.components.progress.linear.background.colourDefault;


  return (0, _styledComponents.css)(['height:', ';background-color:', ';'], (0, _reactackleCore.getValueString)(thickness), colourDefault);
};

var ContentWrapperStyled = exports.ContentWrapperStyled = _styledComponents2.default.div.withConfig({
  displayName: 'ContentWrapperStyled'
})(['position:relative;width:100%;overflow:hidden;order:2;', ''], style);

ContentWrapperStyled.displayName = 'ContentWrapperStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-progress/dist/LinearProgress/styles/ContentWrapperStyled.js
// module id = 763
// module chunks = 0